import axios from "axios"

const noticeApi = {
    getNoticeList: (params) => {
        const url = '/notice'
        return axios.get(url, params)
    },
    getNotice: (noticeId) => {
        const url = `/notice/${noticeId}`
        return axios.get(url)
    },
    addNotice: (params) => {
        const url = '/notice'
        return axios.post(url, params)
    },
    deleteNotice: (noticeId) => {
        const url = `/notice/${noticeId}`
        return axios.delete(url)
    },
    updateNotice: (noticeId, params) => {
        const url = `/notice/${noticeId}`
        return axios.patch(url, params)
    },
    changeNoticeStatus: (noticeId) => {
        const url = `/notice/${noticeId}/status`
        return axios.patch(url)
    },
    getNewestNoticeList: () => {
        const url = '/notice/newest'
        return axios.get(url)
    },

}

export default {
    install(app) {
        app.config.globalProperties.noticeApi = noticeApi
    }
}
